module.exports = __webpack_public_path__ + "img/good.f0c38403.png";